import { contextPath } from "@ocm/services/ocm-object";

export const getOcmRequestUrl = (query = "") => {
	const searchEncoded = encodeURIComponent(query);

	return `${contextPath}/rest/search/classic/autocomplete/?searchString=${searchEncoded}`;
};
